import { Fragment, useState, useEffect, useContext } from 'react';
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import CategoryButtonMenu, { CategoryMenu } from '../../../components/shared/CategoryButtonMenu';
import EventsAnalytics from './EventsAnalytics';
import EventsList from './EventsList';
import MultipleDropDownMenu from '../../../components/shared/MultipleDropDownMenu';
import ViewDropDownMenu from '../../../components/shared/ViewDropDownMenu';
import { PageFilter } from '../../../model/page';
import useStores from '../../../hooks/useStores';
import { PageContext } from '../../../context/page-context';

export default function Events() {
    const [category, setCategory] = useState('analytics');
    let { url } = useRouteMatch();
    const history = useHistory();
    const { categoryName }: UrlParam = useParams();
    const [savedViews] = useState<PageFilter[]>([]);
    const { status: storesStatus, data: stores, isFetching: storeIsFetching } = useStores();
    const { activeFilter, filter, setStores, setStoresFilter, setIsLoaded } = useContext(PageContext);

    useEffect(() => {
        if (categoryName === 'list') {
            setCategory('list');
        } else {
            setCategory('analytics');
        }

    }, [categoryName]);

    useEffect(() => {
        if (!setIsLoaded) return;
        if (storeIsFetching || storesStatus !== "success") {
            setIsLoaded(false);
        }
        if (!storeIsFetching && storesStatus === 'success' && stores && setStores) {
            setStores(stores);
            setIsLoaded(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stores, storesStatus, storeIsFetching]);

    interface UrlParam {
        categoryName: string;
    }

    const selectCategory = (cat: string) => {
        setCategory(cat);
        if (url === '') {
            url = '/events/analytics';
        }
        history.push(`/events/${cat}`);
    }

    const categories: CategoryMenu[] = [{
        name: 'analytics',
        label: 'Analytics'
    },
    {
        name: 'list',
        label: 'List'
    },
    ];

    return (
        <Fragment>

            <Stack spacing={1} sx={{ pr: 1 }}>
                <Stack direction="row" sx={{ mb: 3 }} spacing={2}>
                    <Button color="secondary" sx={{ backgroundColor: 'text.secondary', color: 'white' }} variant="contained">Save View</Button>
                    <ViewDropDownMenu label="Saved Views" views={savedViews} />
                </Stack>

                <Stack direction="row" sx={{ mb: 3, justifyContent: 'space-between' }} spacing={5}>
                    <Stack direction="row" spacing={1} >
                        <CategoryButtonMenu category={category} selectCategory={selectCategory} categories={categories} />
                    </Stack>

                    <Stack direction="row" sx={{ justifyContent: 'flex-end' }} spacing={1} >
                        <MultipleDropDownMenu single={true} label="Level" options={['Corporate', 'District', 'Store']} />
                        <MultipleDropDownMenu label="District" options={['Socal District', 'Nocal District', 'Midwest District', 'East Coast District']} />
                        <MultipleDropDownMenu
                            multipleLabel='Stores'
                            label="Store"
                            search={true}
                            options={filter.stores && filter.stores.length > 0 ? filter.stores : stores ? stores : []}
                            selectHandler={setStoresFilter}
                            selected={activeFilter.stores}
                        />
                    </Stack>
                </Stack>

            </Stack>

            <Grid container={true} spacing={3} sx={{ pt: 3 }}>

                {category === 'analytics' && <EventsAnalytics />}
                {category === 'list' && <EventsList />}

            </Grid>

        </Fragment>
    )

}
